import {styled} from '@mui/material/styles'
import {AlertTitle} from '@mui/material'

export const StyledAlertTitle = styled(AlertTitle)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize
}))
